import { render, staticRenderFns } from "./DraftKirimInven.vue?vue&type=template&id=cbbbfdfe&"
import script from "./DraftKirimInven.vue?vue&type=script&lang=js&"
export * from "./DraftKirimInven.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports